import React from 'react';
import { Link, NavLink } from "react-router-dom";
import Logo from "../assets/images/newlogo.png";
// import Headerimg from "../assets/images/home.png"
import Headerimg from "../assets/images/Img.png";
export default function Header() {

    const Token = localStorage.getItem("Token")
    // console.log("Token",Token)
    return (
        <div>
            <nav
                className="navbar navbar-expand-lg fixed-top navbar-white navbar-custom sticky"
                id="navbar"
            >
                <div className="container">
                    {/* LOGO */}
                    <Link className="navbar-brand text-uppercase" to="/">
                        <img src={Logo} alt="" height={40} />
                    </Link>
                    <button
                        className="navbar-toggler"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#navbarCollapse"
                        aria-controls="navbarCollapse"
                        aria-expanded="false"
                        aria-label="Toggle navigation"
                    >
                        <span className="mdi mdi-menu" />
                    </button>
                    <div className="collapse navbar-collapse" id="navbarCollapse">
                        <ul className="navbar-nav mx-auto" id="navbar-navlist">
                            <li className="nav-item">
                                <NavLink className={({ isActive }) =>
                                    isActive ? "nav-link active" : "nav-link"
                                } to="/">
                                    Home
                                </NavLink>
                            </li>
                            <li className="nav-item">
                                <NavLink className={({ isActive }) =>
                                    isActive ? "nav-link active" : "nav-link"
                                } to="/HowitsWork">
                                    How It Works
                                </NavLink>
                            </li>
                            <li className="nav-item">
                                <NavLink className={({ isActive }) =>
                                    isActive ? "nav-link active" : "nav-link"
                                } to="/Review">
                                    Reviews
                                </NavLink>
                            </li>
                            <li className="nav-item">
                                <NavLink className={({ isActive }) =>
                                    isActive ? "nav-link active" : "nav-link"
                                } to="/Pricing">
                                    Pricing
                                </NavLink>
                            </li>
                            <li className="nav-item">
                                <NavLink className={({ isActive }) =>
                                    isActive ? "nav-link active" : "nav-link"
                                } to="/Faq">
                                    Faq's
                                </NavLink>
                            </li>
                            <li className="nav-item">
                                <NavLink className={({ isActive }) =>
                                    isActive ? "nav-link active" : "nav-link"
                                } to="/Articles">
                                    Articles
                                </NavLink>
                            </li>
                            <li className="nav-item">
                                <NavLink className={({ isActive }) =>
                                    isActive ? "nav-link active" : "nav-link"
                                } to="/Blogs">
                                    Blogs
                                </NavLink>
                            </li>
                        </ul>
                        {Token == null ?
                            <div className="d-flex align-items-center">
                                <Link className="nav-link text-white" to="/Login" style={{ fontFamily: "Poppins", fontWeight: "700", fontSize: "18px" }}>
                                    LOG IN
                                </Link>
                                <div className="me-5 flex-shrink-0 d-none d-lg-block">

                                    <Link className="btn btn-outline-primary " to="/Signup" style={{ fontSize: "18px" }}>
                                        GET STARTED
                                    </Link>
                                </div>
                            </div> :
                            <div className="d-flex align-items-center">
                                <Link className="nav-link text-white" to="/Login">
                                    Welcome
                                </Link>
                                <div className="me-5 flex-shrink-0 d-none d-lg-block">

                                    <Link className="btn btn-outline-primary " to="/Login">
                                        Logout
                                    </Link>
                                </div>
                            </div>}
                    </div>
                </div>
            </nav>
            {/* Start Home  */}
            {/* style={{backgroundImage: 'radial-gradient(farthest-corner at 20% 50%, #a7700070 26%, #000 100%)'}} */}
            {/* style={{background: "radial-gradient(at 30% 50%, rgba(167, 112, 0, 0.44) 0%, transparent), radial-gradient(at 80% 50%, rgb(0 51 167 / 50%) 0%, transparent)"}} */}
            <section className="section bg-gradient-new home" id="home">
                <div className="container">
                    <div className="row align-items-center mt-5 mt-lg-0">
                        <div className="col-lg-5">
                            <div className="home-heading">
                                {/* <h6 className="text-uppercase text-muted">I'm Graphics Designer</h6> */}
                                <h1 className="lh-sm">
                                    THE BEST <br /> AI-POWERED HEADSHOT FOR EVERYONE

                                </h1>
                                <p className="headerpara">
                                    Click, create, and delight in the magic
                                </p>
                            </div>
                            <Link className=" btn btn-primary nav-btn "
                                style={{ fontFamily: "Poppins", fontWeight: "700", borderRadius: "12px", fontSize: "20px" }}
                                to="#" >CREATE YOURS NOW </Link>

                            {/* Modal */}
                            <div className="home-btn d-grid d-sm-block gap-3">
                                <div
                                    className="modal fade bd-example-modal-lg watchvideomodal"
                                    data-keyboard="false"
                                    tabIndex={-1}
                                    aria-hidden="true"
                                >
                                    <div className="modal-dialog modal-dialog-centered modal-dialog modal-lg">
                                        <div className="modal-content home-modal">
                                            <div className="modal-header border-0">
                                                <button
                                                    type="button"
                                                    className="btn-close btn-close-white"
                                                    data-bs-dismiss="modal"
                                                    aria-label="Close"
                                                />
                                            </div>
                                            <video id="VisaChipCardVideo" className="video-box" controls="">
                                                <source
                                                    src="https://www.w3schools.com/html/mov_bbb.mp4"
                                                    type="video/mp4"
                                                />
                                                {/*Browser does not support <video> tag */}
                                            </video>
                                        </div>
                                    </div>
                                </div>
                                {/* END MODAL */}
                            </div>
                        </div>
                        {/* end col*/}
                        <div className="col-lg-7 mt-4">
                            <div className="ms-md-4">
                                <img className="home-img" src={Headerimg} alt="" style={{ width: "90%" }} />
                            </div>
                        </div>

                    </div>
                    {/* end row*/}
                </div>
                {/*end container*/}

            </section>
            {/* <!-- End Home --> */}


        </div>
    )
}
